import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Hero.css";
import Heroimg1 from "../../media/heroimg1.png"; // Background
import Heroshape1 from "../../media/heroshape1.png"; // Left abstract shape
import Heroshape2 from "../../media/heroshape2.png"; // White shape behind blue
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="hero-section position-relative overflow-hidden">
      {/* Background */}
      <img src={Heroimg1} alt="Hero Background" className="hero-bg-img" />

      {/* Gradient overlays */}
      <div className="slider-item">
        <div className="shapes">
          <span className="color-shape-2"></span>
          <span className="color-shape"></span>
        </div>
      </div>

      {/* White shape */}
      <img src={Heroshape2} alt="White Shape" className="hero-shape-2" />

      {/* Left shape */}
      <img src={Heroshape1} alt="Left Shape" className="hero-left-shape" />

      {/* Hero text block with Bootstrap grid */}
      <div className="container position-relative z-2 content-hero">
        <div className="row">
          <div className="col-md-6 col-lg-5">
            <div className="hero-inner-content text-white ">
              <p className="text-uppercase text-white mb-2 fw-bold hero-abc">
                Welcome To Aspen SR
              </p>
              <h1 className="mb-3 hero-main-title">
                Accounting with <span className="green-text">Purpose</span>{" "}
                <br />
              </h1>
              <p className="mb-4 hero-subtitle text-white">
                We’ve Got You Covered. Clarity in Compliance. Confidence in
                Growth.
              </p>
              <Link
                to="/contact"
                className="btn btn-light text-primary-hero fw-bold hero-button"
              >
                Contact Us <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
